module.exports = __webpack_public_path__ + "img/07_01.ec5de853.jpg";